import { Component } from '@angular/core';
import { OrderProgressService } from './services/order-progress.service';
import { LoaderService } from './services/loader.service';
import { AnalyticsService } from './services/analytics.service';
import { BrandService } from './services/brand.service';
import { ConsentUiService } from './services/consent-ui.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    private progressService: OrderProgressService,
    public loaderService: LoaderService,
    private analyticsService: AnalyticsService,
    private brandService: BrandService,
    private consentUi: ConsentUiService
  ) {
    this.analyticsService.setContext({
      environment: environment.production ? 'production' : 'development'
    });
    // Bootstrap baseline: paint the iGive theme so pages without vendor context
    // (receipt, payment, root with no lastStore) render correctly. Pages with
    // vendor context override this via BrandService.apply() once VendorSite
    // loads. Bootstrap does NOT call rememberBrand — only pages that own the
    // brand-determining context persist into sessionStorage, so the recall
    // signal in distribution stays meaningful.
    this.brandService.apply('igive', null);
    // In the background: nothing here waits for the banner.
    this.consentUi.start();
  }
}
